export default "__VITE_ASSET__6232cf2f__"